export default __webpack_public_path__ + "static/media/donald.93387cca.jpg";